export const FINANCIAL_INFO_VIEWS_PATHS = {
  ALL_VIEWS: 'all-views',
  INCOME_AND_EMPLOYMENT: 'income-and-employment',
  LIABILITIES: 'liabilities',
  REO: 'reo',
  ASSETS: 'assets',
};

export const FINANCIAL_INFO_TABLE_KEY = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: 'incomes',
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: 'liabilities',
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: 'properties',
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: 'assets',
};

export const ALL_BORROWERS_PATH = 'all';

export const ALL_BORROWERS_LABEL = 'All Borrowers';

// The field a financial-info borrower lists in modifiedFields when their name changed.
export const BORROWER_FULL_NAME_FIELD = 'BorrowerFullName';

export const FINANCIAL_INFO_ACTION_TYPE = {
  EDIT: 'edit',
  NEW: 'new',
};

export const NEW_RECORD_DATA = {
  id: 'new-record',
  name: '-',
};

export const NEW_RECORD_DEFAULT_APPLICATION_DATA = {
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: {
    hasFirstMortgage: false,
  },
};
